export const GenerateEnum = {
  InspirationBase: 'InspirationBase',
  InspirationHotTopic: 'InspirationHotTopic',
  InspirationRandomWords: 'InspirationRandomWords',
  InspirationToScriptTable: 'InspirationToScriptTable'
}

export const modeEnum = {
  常规模式: 'inspiration_base',
  随机模式: 'inspiration_random_words',
  热点模式: 'inspiration_hot_topic'
}

export const statusMapEnum = {
  '生成完毕-用户已读': {
    backgroundColor: '#c7c7c7',
    text: '已读'
  },
  生成完毕: {
    backgroundColor: '#1c1c1e',
    text: '未读'
  },
  生成中: {
    backgroundColor: '#6a50fdb3',
    text: '生成中'
  },
  草稿: {
    backgroundColor: '#ff000096',
    text: '草稿'
  },
  生成失败: {
    backgroundColor: '#f56c6c',
    text: '失败'
  }
}

export const taskSourceEnum = {
  NOVEL: 'novel',
  SHORT_PLAY: 'shortPlay',
}
